import React from 'react';

const CFOPOperacaoFiscalContext = React.createContext();

export default CFOPOperacaoFiscalContext;
